
import "@/assets/video/error-page.css"
import { VideoInfo } from "@/models/VideoInfo"
import isVideoUrlsValid from "@/utils/VIdeoUrlsValudator"
import { defineComponent, PropType, Ref } from "vue"

export default defineComponent({
  props: {
    videoUrls: {
      type: Object as PropType<Ref<VideoInfo>>,
      required: true
    }
  },
  setup(props) {
    const hasUrlError = !isVideoUrlsValid(props.videoUrls.value, undefined)
    return { hasUrlError }
  }
})
